/**
 * 将 public/ 静态路径拼到文件 CDN（如 https://w3-cdn-files.moji.com）。
 * 未配置 CDN 时保持站内相对路径（如 /images/xxx.svg）。
 *
 * 页面在 www.moji.com 打开时，浏览器请求 CDN 会自动带 Referer: https://www.moji.com/...，
 * 可满足「必须有官网 Referer」的防盗链；curl 测试需自行加 -H 'Referer: ...'。
 */
export function staticURL(path: string): string {
  const raw = typeof path === 'string' ? path.trim() : ''
  if (!raw || raw.startsWith('data:') || raw.startsWith('blob:')) {
    return raw
  }
  // 已是绝对 URL / 协议相对
  if (/^https?:\/\//i.test(raw) || raw.startsWith('//')) {
    return raw
  }

  let base = ''
  try {
    // Nuxt 会把 NUXT_APP_CDN_URL 注入 app.cdnURL；也兼容 public.fileCdnURL
    const config = useRuntimeConfig()
    base = String(config.app?.cdnURL || config.public?.fileCdnURL || '').replace(/\/$/, '')
  } catch {
    base = ''
  }

  const normalized = raw.startsWith('/') ? raw : `/${raw}`
  if (!base) {
    return normalized
  }
  return `${base}${normalized}`
}
